/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CheckPaymentStatusAsOrder200Response
 */
export interface CheckPaymentStatusAsOrder200Response {
  /**
   *
   * @type {boolean}
   * @memberof CheckPaymentStatusAsOrder200Response
   */
  status: boolean
  /**
   *
   * @type {boolean}
   * @memberof CheckPaymentStatusAsOrder200Response
   */
  data: boolean
}

/**
 * Check if a given object implements the CheckPaymentStatusAsOrder200Response interface.
 */
export function instanceOfCheckPaymentStatusAsOrder200Response(
  value: object
): value is CheckPaymentStatusAsOrder200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function CheckPaymentStatusAsOrder200ResponseFromJSON(
  json: any
): CheckPaymentStatusAsOrder200Response {
  return CheckPaymentStatusAsOrder200ResponseFromJSONTyped(json, false)
}

export function CheckPaymentStatusAsOrder200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CheckPaymentStatusAsOrder200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: json['data'],
  }
}

export function CheckPaymentStatusAsOrder200ResponseToJSON(
  value?: CheckPaymentStatusAsOrder200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: value['data'],
  }
}
